module.exports = __webpack_public_path__ + "img/sd.7ab061d8.svg";